module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.2-246.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.2.md
// module id = 687
// module chunks = 280